module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.12597/images/pngs/chapter_thumbnail.png"